<template>
	<div style="background-color:#FFF">
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 text-center"><h3><b>របាយការណ៍សង្ខេប ({{config.datelify((new Date()).getTime()/1000)}})</b></h3></div>
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"><h4><b>ទិន្នន័យសរុបទាំងអស់</b></h4></div>
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
				<div class="md-layout">
					<div class="md-layout-item md-small-size-50 md-size-50">
						<md-table>
							<md-table-row class="disable-hover">
								<md-table-cell style="width: 40%;">អតិថិជនសរុប</md-table-cell>
								<md-table-cell style="width: 50px">:</md-table-cell>
								<md-table-cell><b>{{stat.total_client}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>គម្រោងសរុប</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{stat.total_project}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>អ្នកគ្រប់គ្រងសរុប</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{stat.total_admin}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>ចំនួនរំលោះកំពុងដំណើរការ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{stat.total_loan - stat.total_finish_loan}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>ចំនួនរំលោះបានបញ្ចប់</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{stat.total_finish_loan}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>ចំនួនរំលោះសរុប</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{stat.total_loan}}</b></md-table-cell>
							</md-table-row>
						</md-table>
					</div>
					<div class="md-layout-item md-small-size-50 md-size-50">
						<md-table>
							<md-table-row class="disable-hover">
								<md-table-cell style="width: 40%;">ចំនួនប្រាក់ដើមបានបង់</md-table-cell>
								<md-table-cell style="width: 50px">:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(stat.total_paid_principal)}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>ចំនួនប្រាក់ដើមមិនទាន់បង់</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(stat.total_principal - stat.total_paid_principal)}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>ចំនួនប្រាក់ដើមសរុប</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(stat.total_principal)}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>ចំនួនការប្រាក់បានបង់</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(stat.total_paid_interest)}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>ចំនួនការប្រាក់មិនទាន់បង់</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(stat.total_interest - stat.total_paid_interest)}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>ចំនួនការប្រាក់សរុប</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(stat.total_interest)}}</b></md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
			</div>

			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"><h4><b>ការប្រមូលប្រាក់ប្រចាំខែ{{config.monthKHList[(new Date()).getMonth()]}}</b></h4></div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row class="disable-hover">
								<md-table-cell>ចំនួនប្រាក់ដើមបានប្រមូល / <b>ចំនួនប្រាក់ដើមត្រូវប្រមូល</b></md-table-cell>
								<md-table-cell>ចំនួនការប្រាក់បានប្រមូល / <b>ចំនួនការប្រាក់ត្រូវប្រមូល</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>{{config.moneylify(stat_monthly_payment.total_paid_principal)}} / <b> {{config.moneylify(stat_monthly_payment.total_principal)}}</b></md-table-cell>
								<md-table-cell>{{config.moneylify(stat_monthly_payment.total_paid_interest)}} / <b>&nbsp;{{config.moneylify(stat_monthly_payment.total_interest)}}</b></md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>

			</div>

			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" style="margin-top: 40px"><h4><b>ប្រាក់ចំណូលថ្ងៃនេះ ({{(new Date()).getDate()}}/{{(new Date()).getMonth()+1}}/{{(new Date()).getFullYear()}})</b></h4></div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<div class="md-layout">
					<div class="md-layout-item md-small-size-50 md-size-50">
						<md-table>
							<md-table-row class="disable-hover">
								<md-table-cell style="width: 40%;">ប្រាក់ដើមបានទូទាត់</md-table-cell>
								<md-table-cell style="width: 50px">:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(today.total_paid_principal)}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>ការប្រាក់បានទូទាត់</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(today.total_paid_interest)}}</b></md-table-cell>
							</md-table-row>
						</md-table>
					</div>
					<div class="md-layout-item md-small-size-50 md-size-50">
						<md-table>
							<md-table-row class="disable-hover">
								<md-table-cell style="width: 40%;">ប្រាក់ពិន័យបានទូទាត់</md-table-cell>
								<md-table-cell style="width: 50px">:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(today.total_paid_fine)}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>ប្រាក់ចំណូលសរុប</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(today.total_paid_fine + today.total_paid_principal + today.total_paid_interest)}}</b></md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
			</div>

			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"><h4><b>ប្រាក់ចំណូលខែ{{config.monthKHList[(new Date()).getMonth()]}}</b></h4></div>

			<div class="md-layout-item md-small-size-100 md-size-100">
				<div class="md-layout">
					<div class="md-layout-item md-small-size-50 md-size-50">
						<md-table>
							<md-table-row class="disable-hover">
								<md-table-cell style="width: 40%;">ប្រាក់ដើមបានទូទាត់</md-table-cell>
								<md-table-cell style="width: 50px">:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(month.total_paid_principal)}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell>ការប្រាក់បានទូទាត់</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(month.total_paid_interest)}}</b></md-table-cell>
							</md-table-row>
						</md-table>
					</div>
					<div class="md-layout-item md-small-size-50 md-size-50">
						<md-table>
							<md-table-row class="disable-hover">
								<md-table-cell style="width: 40%;">ប្រាក់ពិន័យបានទូទាត់</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(month.total_paid_fine)}}</b></md-table-cell>
							</md-table-row>
							<md-table-row class="disable-hover">
								<md-table-cell style="width: 50px">ប្រាក់ចំណូលសរុប</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell><b>{{config.moneylify(month.total_paid_fine + month.total_paid_principal + month.total_paid_interest)}}</b></md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
			</div>
			</div>
	</div>
</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: {
			Datetime
		},
		created() {
			this.$http.get(this.config.api + "/admin/get/stat").then(data => {
				this.stat = data.body.data
				this.loaded = true;
			});
			this.$http.get(this.config.api + "/admin/get/stat/today").then(data => {
				this.today = data.body.data
			});
			this.$http.get(this.config.api + "/admin/get/stat/month").then(data => {
				this.month = data.body.data

			});
			this.$http.get(this.config.api + "/admin/get/stat/monthly_payment").then(data => {
				this.stat_monthly_payment= data.body.data
			});
			setTimeout(() => {
					window.print();
			}, 2000)
		},
		computed: {
		},
		methods: {
			getData() {
				let start_date = (new Date(this.range_data.start_date)).getTime();
				let end_date = (new Date(this.range_data.end_date)).getTime();

				this.$http.get(this.config.api + "/admin/get/stat/by_range/" + start_date + "/" + end_date).then(data => {
					this.range = data.body.data
				});
			},
			print() {
				var printContent = document.getElementById("report").innerHTML;
				var originalContent = window.document.body.innerHTML;
				window.document.body.innerHTML = printContent;
				window.print();
				window.document.body.innerHTML = originalContent;
			}
		},
		data() {
			return {
				loaded: false,
				range_data: {
					start_date: "",
					end_date: "",
				},
				stat: {
					total_admin: 0,
					total_loan: 0,
					total_project: 0,
					total_finish_loan: 0,
					total_client: 0,
					total_principal: 0,
					total_interest: 0,
					total_paid_principal: 0,
					total_paid_interest: 0
				},
				stat_monthly_payment: {
					total_paid_principal:0,
					total_paid_interest: 0,
					total_principal: 0,
					total_interest: 0
				},
				today: {
					total_paid_principal: 0,
					total_paid_interest: 0,
					total_paid_fine: 0
				},

				month: {
					total_paid_principal: 0,
					total_paid_interest: 0,
					total_paid_fine: 0
				},
				range: {
					total_paid_principal: 0,
					total_paid_interest: 0,
					total_paid_fine: 0
				}
			}
		}
	}
</script>

<style>
	.disable-hover:hover {
		background-color: #FFF !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/PrintReport.vue